// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tag[data-v-620a5d96]{background:#0a0a0a;color:#fff;display:inline-flex;font-weight:600;font-size:.75rem;padding:.375rem .875rem;border-radius:20px;cursor:default;margin-bottom:.625rem}.tag[data-v-620a5d96]:not(:last-child){margin-right:.625rem}.tag.white[data-v-620a5d96]{background:#fff;color:#0a0a0a;box-shadow:rgba(10,10,10,.08)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
